import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DropdownField from '../FormComponents/DropdownField/DropdownField'
import BasicSettings from './components/BasicSettings'
import AlertsByCategory from './components/AlertsByCategory'
import AlertsByRecord from './components/AlertsByRecord'
import ComplianceAlerts from './components/ComplianceAlerts'
import CustomAlerts from './components/CustomAlerts'
import { updateAlertData } from '../../store/reducers/emailAlerts'
import '../../styles/ModalStyles.scss'
import '../../styles/Select/react-select.scss'
import { page as pageIndex } from '../../globals'
import { emailAlertsConstants } from './constants'
import './css/ManagementEmailAlerts.scss'

class EmailAlerts extends React.PureComponent {
  constructor (props) {
    super(props)
    this.returnBasicSettings = this.returnBasicSettings.bind(this)
    this.returnCategoryBody = this.returnCategoryBody.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  returnBasicSettings = () => {
    return this.props.updateAlertData({ page: pageIndex.dashboard, field: 'emailCategory' }, 'select', 'category', '')
  }

  returnCategoryBody = () => {
    const { emailManagerTrackData, updateAlertData } = this.props
    const categoryType = emailManagerTrackData.emailCategory.radio.category
    const props = {
      trackData: emailManagerTrackData,
      updateData: updateAlertData
    }
    switch (categoryType) {
      case 'legisCategoryAlerts':
      case 'regsCategoryAlerts':
      case 'localCategoryAlerts':
        return <AlertsByCategory {...props} type={categoryType} />
      case 'legisRecordAlerts':
      case 'regsRecordAlerts':
      case 'localRecordAlerts':
        return <AlertsByRecord {...props} type={categoryType} />
      case 'legisComplianceAlerts':
      case 'regsComplianceAlerts':
        return <ComplianceAlerts {...props} type={categoryType} />
      case 'customAlerts':
        return <CustomAlerts {...props} />
      default:
        return <BasicSettings
          trackData={emailManagerTrackData}
          updateData={updateAlertData}
        />
    }
  }

  closeModal = (name) => () => {
    this.props.hideModal(name)
  }

  render () {
    const { emailManagerTrackData, updateAlertData } = this.props
    return <div className="background-white email-alert-comb custom-scroll">
      <div className="form-element">
        <div className="flex-container space-between alerts-title">
          <span className="form-text-subtitle">Alerts Category</span>
        </div>
        <div className="flex-container space-between">
          <div className="col-md-4 col-sm-6 p-0">
            <DropdownField
              id="category"
              location={{ page: pageIndex.dashboard, field: 'emailCategory' }}
              options={emailAlertsConstants.dropDownValues}
              placeholder="Select a Category"
              value={emailManagerTrackData.emailCategory.radio.category}
              updateData={updateAlertData}
            />
          </div>
          <div className="track-blue-button" onClick={this.returnBasicSettings}>Basic Settings</div>
        </div>
      </div>
      <hr className="horizontal-line-hr alerts" />
      {this.returnCategoryBody()}
    </div>
  }

  static propTypes = {
    emailManagerTrackData: PropTypes.object,
    updateAlertData: PropTypes.func,
    hideModal: PropTypes.func
  }
}

export default connect(state => ({
  emailManagerTrackData: state.emailAlerts.formDataValue
}), {
  updateAlertData
})(EmailAlerts)



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/ManagementEmailAlerts.js